import { render } from "./DefaultLayout.vue?vue&type=template&id=3ca1795e"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import "./DefaultLayout.vue?vue&type=style&index=0&id=3ca1795e&lang=css"

import exportComponent from "D:\\Projects\\jimoty\\JimotyWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__